/* AVENEXO — interacciones propias (vanilla, sin librerías) */
(function () {
  if (window.__avInit) return;
  window.__avInit = true;
  document.documentElement.classList.add('av-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Revelado al hacer scroll (un único observer) ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('av-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }) : null;

  function splitLines(el) {
    if (el.dataset.avSplit) return;
    el.dataset.avSplit = '1';
    var html = el.innerHTML.split(/<br\s*\/?>/i);
    el.innerHTML = html.map(function (h, i) {
      return '<span class="av-line" style="--l:' + i + '"><span>' + h + '</span></span>';
    }).join('');
  }

  function initReveal(root) {
    (root || document).querySelectorAll('.av-split').forEach(splitLines);
    (root || document).querySelectorAll('.av-reveal, .av-reveal--img, .av-split, .av-pasos__line').forEach(function (el) {
      if (!io || reduce) { el.classList.add('av-visible'); return; }
      io.observe(el);
    });
  }

  /* ---------- Parallax suave (solo transform) ---------- */
  var parallaxEls = [];
  function initParallax(root) {
    (root || document).querySelectorAll('[data-av-parallax]').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.dataset.avParallax || '0.15');
        var center = r.top + r.height / 2 - vh / 2;
        el.style.setProperty('--py', (-center * k).toFixed(1) + 'px');
      });
      tecScroll();
      maniScroll();
      stickyBar();
      ticking = false;
    });
  }

  /* ---------- Hero: entrada + brillo que sigue al cursor + botones magnéticos ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('.av-hero').forEach(function (hero) {
      requestAnimationFrame(function () { setTimeout(function () { hero.classList.add('av-ready'); }, 60); });
      var stage = hero.querySelector('.av-hero__stage');
      var glow = hero.querySelector('.av-hero__glow');
      if (!stage || !glow || reduce) return;
      stage.addEventListener('pointermove', function (ev) {
        var r = stage.getBoundingClientRect();
        glow.style.setProperty('--gx', ((ev.clientX - r.left) / r.width * 100) + '%');
        glow.style.setProperty('--gy', ((ev.clientY - r.top) / r.height * 100) + '%');
      });
    });
    if (reduce) return;
    (root || document).querySelectorAll('.av-btn[data-magnetic]').forEach(function (b) {
      b.addEventListener('pointermove', function (ev) {
        var r = b.getBoundingClientRect();
        b.style.setProperty('--mx', ((ev.clientX - r.left - r.width / 2) * 0.18) + 'px');
        b.style.setProperty('--my', ((ev.clientY - r.top - r.height / 2) * 0.3) + 'px');
      });
      b.addEventListener('pointerleave', function () { b.style.setProperty('--mx', '0px'); b.style.setProperty('--my', '0px'); });
    });
  }

  /* ---------- Cifras animadas ---------- */
  function initCounters(root) {
    (root || document).querySelectorAll('[data-av-count]').forEach(function (el) {
      var target = parseFloat(el.dataset.avCount);
      if (isNaN(target)) return;
      if (reduce || !io) { el.textContent = target; return; }
      el.textContent = '0';
      var obs = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        obs.disconnect();
        var start = null, dur = 1600;
        function step(t) {
          if (!start) start = t;
          var p = Math.min((t - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 4);
          el.textContent = Math.round(target * eased);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, { threshold: 0.6 });
      obs.observe(el);
    });
  }

  /* ---------- Comparador antes/después ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('.av-compare').forEach(function (c) {
      if (c.dataset.avInit) return;
      c.dataset.avInit = '1';
      var dragging = false;
      function set(x) {
        var r = c.getBoundingClientRect();
        var p = Math.max(2, Math.min(98, (x - r.left) / r.width * 100));
        c.style.setProperty('--pos', p + '%');
        c.classList.add('av-touched');
      }
      c.addEventListener('pointerdown', function (e) { dragging = true; c.setPointerCapture(e.pointerId); set(e.clientX); });
      c.addEventListener('pointermove', function (e) { if (dragging) set(e.clientX); });
      c.addEventListener('pointerup', function () { dragging = false; });
      c.addEventListener('pointercancel', function () { dragging = false; });
      c.addEventListener('keydown', function (e) {
        var cur = parseFloat(getComputedStyle(c).getPropertyValue('--pos')) || 50;
        if (e.key === 'ArrowLeft') { c.style.setProperty('--pos', Math.max(2, cur - 5) + '%'); e.preventDefault(); }
        if (e.key === 'ArrowRight') { c.style.setProperty('--pos', Math.min(98, cur + 5) + '%'); e.preventDefault(); }
      });
      // Pequeña demostración automática al entrar en pantalla
      if (!reduce && io) {
        var demo = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          demo.disconnect();
          var t0 = null;
          function anim(t) {
            if (c.classList.contains('av-touched')) return;
            if (!t0) t0 = t;
            var p = (t - t0) / 2200;
            if (p > 1) { c.style.setProperty('--pos', '50%'); return; }
            c.style.setProperty('--pos', (50 + Math.sin(p * Math.PI * 2) * 22) + '%');
            requestAnimationFrame(anim);
          }
          setTimeout(function () { requestAnimationFrame(anim); }, 500);
        }, { threshold: 0.6 });
        demo.observe(c);
      }
    });
  }

  /* ---------- Escena sticky de tecnología ---------- */
  var tecs = [];
  function initTec(root) {
    (root || document).querySelectorAll('.av-tec').forEach(function (t) { if (tecs.indexOf(t) === -1) tecs.push(t); });
  }
  function tecScroll() {
    var mid = window.innerHeight * 0.5;
    tecs.forEach(function (t) {
      var steps = t.querySelectorAll('.av-tec__step');
      var imgs = t.querySelectorAll('.av-tec__img');
      var bars = t.querySelectorAll('.av-tec__progress span');
      var active = 0;
      steps.forEach(function (s, i) { if (s.getBoundingClientRect().top < mid) active = i; });
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === active); });
      imgs.forEach(function (s, i) { s.classList.toggle('is-active', i === active); });
      bars.forEach(function (s, i) { s.classList.toggle('is-active', i <= active); });
    });
  }

  /* ---------- Manifiesto: palabras que se iluminan con el scroll ---------- */
  var manis = [];
  function initMani(root) {
    (root || document).querySelectorAll('.av-mani__quote').forEach(function (q) {
      if (!q.dataset.avWords) {
        q.dataset.avWords = '1';
        var walker = document.createTreeWalker(q, NodeFilter.SHOW_TEXT);
        var nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        nodes.forEach(function (n) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w.trim()) { frag.appendChild(document.createTextNode(w)); return; }
            var s = document.createElement('span'); s.className = 'av-word'; s.textContent = w; frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        });
      }
      if (manis.indexOf(q) === -1) manis.push(q);
    });
  }
  function maniScroll() {
    var vh = window.innerHeight;
    manis.forEach(function (q) {
      var r = q.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      var words = q.querySelectorAll('.av-word');
      var n = Math.round(p * words.length);
      words.forEach(function (w, i) { w.classList.toggle('is-on', reduce || i < n); });
    });
  }

  /* ---------- Acordeones (FAQ y producto) ---------- */
  function initAccordion(root) {
    (root || document).querySelectorAll('.av-faq__q').forEach(function (b) {
      if (b.dataset.avInit) return;
      b.dataset.avInit = '1';
      b.addEventListener('click', function () {
        var item = b.closest('.av-faq__item');
        var open = item.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Inclinación 3D sutil en tarjetas ---------- */
  function initTilt(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-av-tilt]').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 6) + 'deg) translateY(-4px)';
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------- Añadir al carrito (abre el carrito lateral de Dawn si existe) ---------- */
  function addToCart(form, btn, msg) {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var fd = new FormData(form);
    if (drawer && drawer.getSectionsToRender) {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    var label = btn.innerHTML;
    btn.setAttribute('disabled', 'disabled');
    btn.style.opacity = '0.7';
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.removeAttribute('disabled'); btn.style.opacity = '';
      if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
      if (drawer && drawer.renderContents) {
        var show = function (r) { drawer.classList.remove('is-empty'); drawer.renderContents(r); };
        // Si está activo el descuento de 10 minutos, se aplica antes de dibujar el carrito (una sola vez, sin saltos)
        if (window.avCartTimerPrepare) window.avCartTimerPrepare(res).then(show, function () { show(res); });
        else show(res);
      } else {
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
      }
    }).catch(function () { form.submit(); });
    btn.innerHTML = label;
  }

  function initBuyForms(root) {
    (root || document).querySelectorAll('form[data-av-buy]').forEach(function (form) {
      if (form.dataset.avInit) return;
      form.dataset.avInit = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(form, form.querySelector('[type=submit]'), form.parentElement.querySelector('.av-pdp__msg'));
      });
    });
  }

  /* ---------- Selector de color de la portada ---------- */
  function initColor(root) {
    (root || document).querySelectorAll('.av-color').forEach(function (sec) {
      if (sec.dataset.avInit) return;
      sec.dataset.avInit = '1';
      var sw = sec.querySelectorAll('.av-swatch');
      var imgs = sec.querySelectorAll('.av-color__stage img');
      var input = sec.querySelector('input[name=id]');
      var price = sec.querySelector('[data-av-price]');
      var btn = sec.querySelector('[type=submit]');
      // Barra de compra fija de la portada (la misma que en la ficha de producto)
      var hs = sec.querySelector('[data-av-home-sticky]');
      var hsPrice = hs ? hs.querySelector('[data-av-sticky-price]') : null;
      if (hs && !document.querySelector('.av-pdp__sticky:not([data-av-home-sticky])')) {
        homeSticky = hs; homeForm = sec.querySelector('form[data-av-buy]');
        var hbtn = hs.querySelector('button');
        // Añade directamente al carrito lo que esté marcado (color y pack)
        if (hbtn && btn && homeForm) hbtn.addEventListener('click', function () { btn.click(); });
        stickyBar();
      }
      sw.forEach(function (s, i) {
        s.addEventListener('click', function () {
          sw.forEach(function (x) { x.classList.toggle('is-active', x === s); x.setAttribute('aria-pressed', x === s ? 'true' : 'false'); });
          imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
          if (input && s.dataset.variant) input.value = s.dataset.variant;
          if (price && s.dataset.price) price.textContent = s.dataset.price;
          if (hsPrice && s.dataset.price) hsPrice.textContent = s.dataset.price;
          if (btn) {
            var ok = s.dataset.available !== 'false';
            btn.disabled = !ok;
            var lbl = btn.querySelector('span');
            if (lbl) lbl.textContent = ok ? btn.dataset.add : btn.dataset.soldout;
          }
        });
      });
    });
  }

  /* ---------- Página de producto: galería, variantes, cantidad, barra fija ---------- */
  var sticky = null, stickyAnchor = null;
  var homeSticky = null, homeForm = null;
  function stickyBar() {
    if (homeSticky && homeForm) {
      // Portada: aparece al bajar pasado el inicio y se esconde mientras el botón de compra está en pantalla
      var hr = homeForm.getBoundingClientRect();
      var hIn = hr.top < window.innerHeight && hr.bottom > 0;
      homeSticky.classList.toggle('is-on', !hIn && window.scrollY > window.innerHeight * 0.6);
    }
    if (!sticky || !stickyAnchor) return;
    var r = stickyAnchor.getBoundingClientRect();
    // Se ve desde el principio y solo se esconde mientras el botón principal está en pantalla
    var inView = r.top < window.innerHeight && r.bottom > 0;
    sticky.classList.toggle('is-on', !inView);
  }
  function initPdp(root) {
    (root || document).querySelectorAll('.av-pdp').forEach(function (pdp) {
      if (pdp.dataset.avInit) return;
      pdp.dataset.avInit = '1';
      var main = pdp.querySelector('.av-pdp__main');
      var slides = pdp.querySelectorAll('.av-pdp__main > img, .av-pdp__main > .av-pdp__video');
      var thumbs = pdp.querySelectorAll('.av-pdp__thumb');
      var current = 0;
      function go(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) {
          s.classList.toggle('is-active', j === current);
          var v = s.querySelector && s.querySelector('video');
          if (v) { if (j === current) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause(); }
        });
        if (main) main.classList.toggle('is-video', !!(slides[current] && slides[current].classList.contains('av-pdp__video')));
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === current); });
        // Centra la miniatura moviendo solo la fila de miniaturas (scrollIntoView arrastraba toda la página)
        var tb = thumbs[current], tw = tb && tb.parentElement;
        if (tw && tw.scrollWidth > tw.clientWidth) {
          var tr = tb.getBoundingClientRect(), wr = tw.getBoundingClientRect();
          tw.scrollTo({ left: tw.scrollLeft + (tr.left - wr.left) - (wr.width - tr.width) / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = pdp.querySelector('[data-av-prev]'), next = pdp.querySelector('[data-av-next]');
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); go(current - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); go(current + 1); });
      if (main) {
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
          sx = null;
        });
        if (!window.matchMedia('(hover: none)').matches) {
          main.addEventListener('click', function () { main.classList.toggle('is-zoom'); });
          main.addEventListener('pointermove', function (e) {
            var r = main.getBoundingClientRect();
            main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
            main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
          });
          main.addEventListener('pointerleave', function () { main.classList.remove('is-zoom'); });
        }
      }

      // Variantes
      var dataEl = pdp.querySelector('[data-av-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = pdp.querySelector('form[data-av-buy]');
      var idInput = form ? form.querySelector('input[name=id]') : null;
      var priceEl = pdp.querySelector('[data-av-price]');
      var compareEl = pdp.querySelector('[data-av-compare]');
      var saveEl = pdp.querySelector('[data-av-save]');
      var btn = form ? form.querySelector('[type=submit]') : null;
      var stickyPrice = document.querySelector('[data-av-sticky-price]');
      var groups = pdp.querySelectorAll('.av-pdp__opt');
      function money(c) {
        var f = pdp.dataset.moneyFormat || '{{amount}}';
        var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
        var kind = m ? m[1] : 'amount';
        var n = (c / 100).toFixed(kind.indexOf('no_decimals') > -1 ? 0 : 2);
        var parts = n.split('.');
        var thou = kind.indexOf('comma') > -1 ? '.' : (kind.indexOf('apostrophe') > -1 ? "'" : ',');
        var dec = kind.indexOf('comma') > -1 ? ',' : '.';
        if (kind.indexOf('space') > -1) { thou = ' '; dec = ','; }
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        return f.replace(/\{\{\s*\w+\s*\}\}/, parts.join(dec));
      }
      function selected() {
        var vals = [];
        groups.forEach(function (g) { var a = g.querySelector('.av-pdp__value.is-active'); vals.push(a ? a.dataset.value : null); });
        return vals;
      }
      function update() {
        var vals = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
        groups.forEach(function (g, gi) {
          var lab = g.querySelector('[data-av-opt-current]');
          if (lab) lab.textContent = vals[gi];
        });
        if (!v) { if (btn) { btn.disabled = true; btn.querySelector('span').textContent = btn.dataset.unavailable; } return; }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
        if (saveEl) {
          if (v.compare_at_price > v.price) { saveEl.style.display = ''; saveEl.textContent = saveEl.dataset.prefix + ' ' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
          else saveEl.style.display = 'none';
        }
        if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? btn.dataset.add : btn.dataset.soldout; }
        if (v.featured_media && v.featured_media.id) {
          var idx = Array.prototype.findIndex.call(slides, function (s) { return s.dataset.mediaId == v.featured_media.id; });
          if (idx > -1) go(idx);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      groups.forEach(function (g) {
        g.querySelectorAll('.av-pdp__value').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('.av-pdp__value').forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            update();
            // Al elegir un color, sube hasta la foto para ver el cepillo en ese color (si no se ve ya).
            // En el móvil no: le haría perder el selector de packs y el botón de compra.
            if (main && !b.classList.contains('av-pdp__value--text') && window.matchMedia('(min-width: 750px)').matches) {
              // El menú reaparece al subir: se reserva su altura para que no tape la foto
              var head = document.querySelector('.section-header');
              var hh = head ? head.offsetHeight : 0;
              var r = main.getBoundingClientRect();
              if (r.top < Math.max(hh, 0) || r.bottom > window.innerHeight) {
                window.scrollTo({ top: window.scrollY + r.top - Math.max(hh, 0) - 12, behavior: 'smooth' });
              }
            }
          });
        });
      });

      // Cantidad
      var q = pdp.querySelector('.av-qty input');
      pdp.querySelectorAll('.av-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(q.value, 10) || 1) + (b.dataset.step === '+' ? 1 : -1));
          q.value = n;
        });
      });

      // Barra de compra fija
      sticky = document.querySelector('.av-pdp__sticky');
      stickyAnchor = form;
      var sbtn = sticky ? sticky.querySelector('button') : null;
      // Añade directamente al carrito lo que esté marcado (color y pack)
      if (sbtn && btn) sbtn.addEventListener('click', function () { btn.click(); });

      // Fechas de entrega estimadas
      pdp.querySelectorAll('[data-av-eta]').forEach(function (el) {
        var fmt = function (d, withMonth) {
          return d.toLocaleDateString('es-ES', withMonth ? { day: 'numeric', month: 'long' } : { day: 'numeric' });
        };
        var a = new Date(), b = new Date();
        a.setDate(a.getDate() + (parseInt(el.dataset.min, 10) || 9));
        b.setDate(b.getDate() + (parseInt(el.dataset.max, 10) || 14));
        var same = a.getMonth() === b.getMonth();
        el.textContent = el.dataset.avEta.replace('{desde}', fmt(a, !same)).replace('{hasta}', fmt(b, true));
      });

      // Enlace a opiniones: baja hasta la sección de opiniones de la página
      pdp.querySelectorAll('[data-av-reviews-link]').forEach(function (a) {
        var target = document.querySelector('#opiniones, .reviews-section, .av-resenas');
        if (!target) { a.style.display = 'none'; return; }
        a.addEventListener('click', function (e) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    });
  }

  function initAll(root) {
    initReveal(root); initParallax(root); initHero(root); initCounters(root); initCompare(root);
    initTec(root); initMani(root); initAccordion(root); initTilt(root); initBuyForms(root); initColor(root); initPdp(root);
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // Editor de Shopify: re-inicializar al añadir/cambiar secciones
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
